import type { Doc } from "building-types/doc";
import { DocEntityNodeBase, type DocEntityNodeSource } from "../docEntityNodeBase";
import type { DocEntityReference } from "../docEntityReferenceTypes";
import type { DocEntityTypeToHandleType } from "../docEntityTypeToHandleType";

/**
 * TEMP SCAFFOLDING FOR LEGACY PROFILE_EXTRUSION_DESCRIPTOR FALLBACK, WILL BE REMOVED
 * ProfileId fields (wallRoofBaseBoardProfile, baseBoardType, cornerBoardProfile, sweep.profileId,
 * etc. — see profileTypes.ts) declare both the legacy PROFILE_CATALOG_SETTINGS-embedded
 * PROFILE_EXTRUSION_DESCRIPTOR catalog item and the new doc.profiles PROFILE entity. Like
 * STAIR_CATALOG_SETTINGS (see StairSystemDocEntityNode.ts), PROFILE_EXTRUSION_DESCRIPTOR isn't
 * itself a DocEntityType — it resolves through the generic CATALOG_ITEM handle. So the
 * schema-derived reference is relabeled here before it ever reaches the generic FK reference
 * validator (docEntityNodeSchemaUtils.ts), or it gets silently dropped there as an unrecognized
 * candidate type — reporting a legacy-only profile (not yet copied into doc.profiles) as a missing
 * reference even though it resolves fine everywhere else (pickers, generation, "go to" navigation).
 *
 * Shared by every entity type with a PROFILE_EXTRUSION_DESCRIPTOR-typed field: FACADE_SWEEP_STRATUM,
 * ROOF, SETTINGS, WALL_PLANE_TRIM (see docEntityTypeToForeignKeyRelations.ts).
 *
 * This can be removed once the legacy settings-embedded profile catalog is fully migrated. At
 * that point also revisit `pushMissingProfileReferenceIssue`
 * (building-generation/elements/profileMissingReference.ts)
 *
 * */
export class ProfileExtrusionDescriptorFallbackDocEntityNode<
  T extends keyof DocEntityTypeToHandleType,
> extends DocEntityNodeBase<T> {
  constructor(handle: DocEntityTypeToHandleType[T], doc: Doc, docEntityNodeSource: DocEntityNodeSource) {
    super(handle, doc, docEntityNodeSource);
  }

  getForeignKeyReferences(): DocEntityReference[] {
    return super
      .getForeignKeyReferences()
      .map((ref) =>
        (ref.referencedEntityType as string) === "PROFILE_EXTRUSION_DESCRIPTOR"
          ? { ...ref, referencedEntityType: "CATALOG_ITEM" }
          : ref,
      );
  }
}
